import styled from 'styled-components'
import { Button } from '@/components'
import { Tokens } from '@/assets/tokens'

export const MenuContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const MenuButton = styled(Button.Root)<{
  $isOpen?: boolean
  $size?: 'small' | 'medium'
}>`
  min-width: ${({ $size }) => ($size === 'small' ? '24px' : '32px')} !important;
  width: ${({ $size }) => ($size === 'small' ? '24px' : '32px')} !important;
  height: ${({ $size }) => ($size === 'small' ? '24px' : '32px')} !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border-radius: ${({ $size }) => ($size === 'small' ? '4px' : '6px')} !important;
  background-color: ${({ $isOpen }) => ($isOpen ? Tokens.ColorHover : 'transparent')} !important;

  &:hover:not(:disabled) {
    background-color: ${Tokens.ColorHover} !important;
  }

  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.5 !important;
  }
`

export const MenuDropdown = styled.div<{ $placement?: 'left' | 'right' }>`
  position: absolute;
  top: calc(100% + 2px);
  ${({ $placement }) => ($placement === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: 9999;
  min-width: 180px;
  background-color: ${Tokens.ColorWhite};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 4px 0;

  /* Seta do dropdown */
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    ${({ $placement }) => ($placement === 'left' ? 'left: 12px;' : 'right: 12px;')}
    width: 12px;
    height: 12px;
    background-color: ${Tokens.ColorWhite};
    border-left: 1px solid ${Tokens.ColorBorder};
    border-top: 1px solid ${Tokens.ColorBorder};
    transform: rotate(45deg);
  }
`

export const MenuItem = styled.button<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? Tokens.ColorTextTertiary : Tokens.ColorTextPrimary)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background-color: ${Tokens.ColorHover};
  }

  &:active:not(:disabled) {
    background-color: ${Tokens.ColorUIPrimary};
  }
`

export const MenuIcon = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${({ $disabled }) => ($disabled ? Tokens.ColorTextTertiary : Tokens.ColorTextSecondary)};
`

export const MenuText = styled.span<{ $disabled?: boolean }>`
  flex: 1;
  text-align: left;
  font-weight: 500;
  color: ${({ $disabled }) => ($disabled ? Tokens.ColorTextTertiary : Tokens.ColorTextPrimary)};
`
